<template>
  <SoDialog
    ref="dialog"
    v-model="value"
    card-title="Delete User"
    data-testid="user-delete-modal"
  >
    <p class="text-body-1 font-weight-medium mb-6">
      Are you sure you want to delete this user?
    </p>
    <div class="d-flex gap-2">
      <SoButton
        title="Delete"
        type="danger"
        data-testid="user-delete-account-btn"
        @click="deleteUser"
      />
      <SoButton title="Cancel" type="secondary" @click="value = false" />
    </div>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoDialog from "@/components/SoDialog.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import { useSnackbarStore } from "@/stores/snackbar"
  import { RouteNames } from "@/types/router"
  import { UserMutator } from "@/mutators/user/UserMutator"
  import { errorReporter } from "@/services/ErrorService"

  export default defineComponent({
    components: {
      SoButton,
      SoDialog,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        userId: Number(this.$route.params.userId),
        snackbar: useSnackbarStore(),
        deleteUserMutation: UserMutator.delete(),
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
    methods: {
      async deleteUser() {
        try {
          await this.deleteUserMutation.mutate(this.userId)
          this.$router.push({ name: RouteNames.AdminUserList })
          this.snackbar.addSuccess("User deleted")
        } catch (error) {
          console.error(error)
          errorReporter.report(error)
          this.snackbar.addError("Failed to delete user")
        }
      },
    },
  })
</script>
